<template />

<script setup lang="ts">
import { getCurrentInstance, onMounted, onUnmounted } from 'vue'

const emit = defineEmits<{
  notify: [DOMRectReadOnly]
}>()

let observer: ResizeObserver | undefined = undefined

onMounted(() => {
  observer = new ResizeObserver((entries) => emit('notify', entries[0].contentRect))

  const target = getCurrentInstance()?.proxy?.$parent?.$el

  if (target) {
    observer.observe(target)
  }
})

onUnmounted(() => {
  observer?.disconnect()
  observer = undefined
})
</script>
